module.exports = __webpack_public_path__ + "img/e_2_19_r.26bb9c3b.png";